export const TrustBar = () => {
  return (
    <section 
      className="bg-emerald-800 text-white py-4 overflow-hidden"
      data-testid="trust-bar"
    >
      <div className="flex animate-scroll">
        {[0, 1, 2, 3].map((i) => (
          <div 
            key={i} 
            className="flex items-center gap-8 px-8 whitespace-nowrap"
          >
            <span className="text-sm font-medium">
              Fast and Easy Financing - 450 Credit Score or Higher, "You will be approved" - Sam
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrustBar;
